import React, { useCallback, useEffect, useState } from 'react';
import { Document, Page } from 'react-pdf/dist/entry.webpack';
import styles from './layoff.module.scss';

/**
 * Renders a PDF blob at the width of its container (and re-renders when that changes)
 */
const PdfDocument = ({ file }) => {
  const [node, setNode] = useState(null);
  const [width, setWidth] = useState(0);
  const [numPages, setNumPages] = useState(1);
  const [failed, setFailed] = useState(false);
  const container = useCallback((element) => setNode(element), []);

  useEffect(() => {
    if (!node) {
      return undefined;
    }
    const measure = () => setWidth(Math.max(node.clientWidth - 24, 200));
    measure();
    window.addEventListener('resize', measure);
    return () => window.removeEventListener('resize', measure);
  }, [node]);

  // A new file gets a fresh try
  useEffect(() => setFailed(false), [file]);

  return (
    <div className={styles.preview} ref={container}>
      {failed && (
        <p role='alert'>
          The document could not be loaded. Please close it and try again.
        </p>
      )}
      {file && width > 0 && !failed && (
        <Document
          file={file}
          onLoadSuccess={({ numPages: pages }) => setNumPages(pages)}
          onLoadError={() => setFailed(true)}
          loading={<p>Loading document...</p>}
        >
          {Array.from(new Array(numPages), (el, index) => (
            <Page key={index} pageNumber={index + 1} width={width} />
          ))}
        </Document>
      )}
    </div>
  );
};

export default PdfDocument;
